import { combineReducers } from '@reduxjs/toolkit';

import { featuresReducer } from '@app/store/slices/features';

// TODO: Once we have updated all of the `RootState` imports,
// we can use this file solely as a export manifest and
// begin importing from `combined-reducers.ts`.
import {
    alertReducer,
    collectionPageReducer,
    detailViewReducer,
    globalNavigationReducer,
    twoFactorAuthReducer,
    wishlistReducer,
    yatPageReducer,
} from '../slices';

import { adminInfo } from './admin-info';
import { artifacts } from './artifacts';
import { auth } from './auth';
import { crypto } from './crypto';
import { dashboard } from './dashboard';
import { display } from './display';
import { editions } from './editions';
import { emoji } from './emoji';
import { loader } from './loader';
import { nft } from './nft';
import { nftManager } from './nft-manager';
import { notifications } from './notification';
import { organizations } from './organizations';
import { partnerIntegrations } from './partner-integrations';
import { picker } from './picker';
import { transfers } from './transfers';
import { user } from './user';
import { userEmojis } from './user-emojis';
import { waitlist } from './waitlist';

export const rootReducer = combineReducers({
    adminInfo,
    alert: alertReducer,
    artifacts,
    auth,
    crypto,
    dashboard,
    detailView: detailViewReducer,
    collectionPage: collectionPageReducer,
    wishlist: wishlistReducer,
    display,
    editions,
    emoji,
    featureFlags: featuresReducer,
    loader,
    nftManager,
    nft,
    notifications,
    organizations,
    partnerIntegrations,
    picker,
    transfers,
    twoFactorAuth: twoFactorAuthReducer,
    userEmojis,
    user,
    waitlist,
    yatPage: yatPageReducer,
    globalNavigation: globalNavigationReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
